import type { IconName } from '../utils/icons'

export const brandName = 'Kit Educación Física Lista™'
export const price = '$19.990'
export const priceCurrency = 'ARS'
export const fullPrice = '$110.000'

export type Stat = {
  value: number
  prefix?: string
  suffix?: string
  label: string
}

export const stats: Stat[] = [
  { value: 1400, prefix: '+', label: 'Actividades y fichas listas para usar' },
  { value: 1500, prefix: '+', label: 'Profesores satisfechos en todo el país' },
  { value: 5200, suffix: '+', label: 'Horas de planificación ahorradas' },
  { value: 98, suffix: '%', label: 'De los profes lo recomiendan' },
]

export const differenceStats: Stat[] = [
  {
    value: 1400,
    prefix: '+',
    label: 'Unidades y actividades, de 1º Primaria a 6º Secundaria',
  },
  { value: 12, label: 'Volúmenes digitales completos, uno por grado' },
  { value: 100, suffix: '%', label: 'Descarga inmediata tras el pago' },
]

export const marqueeItems = [
  'Descarga instantánea',
  'Pago único',
  'Acceso de por vida',
  'Garantía de 7 días',
  '1º Primaria → 6º Secundaria',
  '+1.400 actividades',
]

export type ComparisonRow = {
  beforeTitle: string
  beforeText: string
  afterTitle: string
  afterText: string
}

export const comparisonRows: ComparisonRow[] = [
  {
    beforeTitle: 'Horas robadas',
    beforeText: 'Fines de semana enteros buscando juegos en Google o Pinterest.',
    afterTitle: 'Seguridad total',
    afterText: '5 minutos de lectura y entrás al patio con autoridad.',
  },
  {
    beforeTitle: 'Caos en el patio',
    beforeText: 'Actividades que no funcionan porque no son para esa edad.',
    afterTitle: 'Progresión real',
    afterText: 'Actividades probadas y adaptadas al nivel de cada grado.',
  },
  {
    beforeTitle: 'Cero estructura',
    beforeText: 'Clases sueltas, sin conexión entre trimestres.',
    afterTitle: 'Planificación anual',
    afterText: 'Un hilo conductor de 1º grado a 6º secundaria.',
  },
  {
    beforeTitle: 'Burocracia infinita',
    beforeText: 'Sufrir cada vez que hay que hacer informes o rúbricas.',
    afterTitle: 'Evaluación express',
    afterText: 'Planillas, rúbricas y reportes listos al 100%.',
  },
  {
    beforeTitle: 'Alumnos dispersos',
    beforeText: 'Chicos que se aburren porque “siempre hacemos lo mismo”.',
    afterTitle: 'Motivación extrema',
    afterText: 'Juegos, desafíos y deportes que los mantienen activos.',
  },
]

export type RecognizeItem = {
  icon: IconName
  title: string
  text: string
}

export const recognizeItems: RecognizeItem[] = [
  {
    icon: 'brain',
    title: 'Ansiedad del domingo a la noche',
    text: 'Llegar al lunes sin saber qué hacer con ese curso difícil.',
  },
  {
    icon: 'calendarX',
    title: 'Domingos robados',
    text: 'Pasar el día armando planificaciones que te piden los directivos en vez de descansar.',
  },
  {
    icon: 'fileSearch',
    title: 'Caos creativo',
    text: 'Buscar fichas modernas y llamativas, pero solo encontrar fotocopias borrosas de hace 20 años.',
  },
  {
    icon: 'clipboardList',
    title: 'Evaluación eterna',
    text: 'No tener una forma clara de evaluar y terminar poniendo notas “a ojo”.',
  },
  {
    icon: 'users',
    title: 'Alumnos desconectados',
    text: 'Sentir que los chicos de secundaria no quieren hacer nada y los de primaria se descontrolan.',
  },
]

export type PackItem = {
  icon: IconName
  title: string
  text: string
}

export const packItems: PackItem[] = [
  {
    icon: 'bookOpen',
    title: '12 volúmenes basados en el calendario escolar',
    text: 'Un currículum completo, desde el esquema corporal en 1º grado hasta el liderazgo deportivo en 6º secundaria.',
  },
  {
    icon: 'footprints',
    title: 'Fichas de actividad «Listas para el patio»',
    text: 'Explicaciones claras, variantes y consejos de seguridad para cada ejercicio.',
  },
  {
    icon: 'megaphone',
    title: 'Scripts de control y orden',
    text: 'Qué decir exactamente para recuperar la atención del grupo sin gritar.',
  },
  {
    icon: 'target',
    title: 'Recursos visuales y Skill Cards',
    text: 'Láminas para explicar técnicas y tácticas que los chicos entienden a la primera.',
  },
  {
    icon: 'clipboardCheck',
    title: 'Evaluaciones, rúbricas e informes',
    text: 'Herramientas de seguimiento para que completar el boletín sea un trámite de 5 minutos.',
  },
  {
    icon: 'trendingUp',
    title: 'Claves de progresión motriz',
    text: 'La hoja de ruta para que tus alumnos realmente mejoren año tras año.',
  },
]

export type GradeGroup = {
  level: string
  grades: string[]
}

export const gradeGroups: GradeGroup[] = [
  { level: 'Primaria', grades: ['1º', '2º', '3º', '4º', '5º', '6º'] },
  { level: 'Secundaria', grades: ['1º', '2º', '3º', '4º', '5º', '6º'] },
]

export const pageSamples = [
  {
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/4e730058-d23a-4029-893b-b7577d5f2ee1.jpg',
    level: '1º Primaria · Ficha',
    title: 'Lateralidad y espacio',
    caption:
      'Ficha lista para imprimir con 10 desafíos de coordinación básica: saltos, cruces y desplazamientos con casilleros para marcar.',
  },
  {
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/1b4f2f6f-1072-41ff-b73a-83956093a47d.jpg',
    level: '4º Primaria · Infografía',
    title: 'Iniciación al hándbol',
    caption:
      'Infografía técnica con la posición del cuerpo, los tipos de pase y el esquema de cancha para explicarlo en dos minutos.',
  },
  {
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/6f251239-7f9a-4b42-9199-599665e14a74.jpg',
    level: '2º Secundaria · Entrenamiento',
    title: 'Circuito de fuerza funcional',
    caption:
      'Circuito de seis estaciones sin materiales, pensado para grupos numerosos, con tiempos y progresiones ya calculadas.',
  },
  {
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/5d3259d5-c6dc-4739-a0b0-e48fc1200c1f.jpg',
    level: '5º Secundaria · Táctica',
    title: 'Táctica de invasión',
    caption:
      'Mapa de desplazamientos para básquet y fútbol escolar, con referencias de posiciones, pases y coberturas.',
  },
]

export const bonuses = [
  {
    title: 'Kit SOS: clases express sin material',
    was: '$9.000',
    text: '30 clases de emergencia para cuando no tenés ni una pelota.',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/234aa6d7-c5fe-4fb1-9824-e039105531dc.jpg',
  },
  {
    title: 'Mapa 3x3 de adaptación instantánea',
    was: '$8.500',
    text: 'Cómo adaptar cualquier clase a patios chicos o grupos de 40 alumnos.',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/7ceb9e69-3d9e-45d6-9aae-7c8b9ea46b05.jpg',
  },
  {
    title: 'Scripts de orden para grupos difíciles',
    was: '$12.000',
    text: 'Frases listas para calmar el caos sin perder la voz.',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/4331ca11-bf46-446f-92df-b1a1a637efb1.jpg',
  },
  {
    title: 'Evaluación express en 5 minutos',
    was: '$7.500',
    text: 'El sistema para poner notas justas sin burocracia.',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/cf0dd865-5f18-420c-b342-a216405d20ee.jpg',
  },
  {
    title: 'Pack de comunicación para familias',
    was: '$8.000',
    text: 'Notas e informes listos para copiar y mandar por cuaderno o WhatsApp.',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/d4b29e7e-4048-4079-ae46-2730a61119d8.jpg',
  },
]

export const offerRows = [
  { label: 'Kit Educación Física Lista™ (12 volúmenes)', value: '$65.000' },
  { label: '5 Bonos Estratégicos Exclusivos', value: '$45.000' },
]

export const testimonials = [
  {
    quote:
      'Por fin recuperé mis fines de semana. Las clases del Kit son prácticas y a los chicos les encantan.',
    name: 'Mariana G.',
    role: 'Profe de EF, Primaria',
    location: 'Córdoba',
  },
  {
    quote:
      'El volumen de secundaria me salvó la vida con los grupos más grandes. Material profesional y muy bien organizado.',
    name: 'Juan Pablo M.',
    role: 'Profe de EF, Secundaria',
    location: 'Buenos Aires',
  },
  {
    quote:
      'Es la mejor inversión que hice en mi carrera. De 1º a 6º año, tengo todo resuelto.',
    name: 'Carla R.',
    role: 'Coordinadora de EF',
    location: 'Mendoza',
  },
]

export const faqs = [
  {
    q: '¿Cómo recibo el material?',
    a: 'De forma inmediata en tu email tras el pago. Son archivos PDF listos para imprimir o ver en el celu.',
  },
  {
    q: '¿Sirve para escuelas con poco material?',
    a: 'Sí. Incluimos un bono específico para adaptar las clases a cualquier contexto, patios chicos y grupos numerosos.',
  },
  {
    q: '¿El pago es mensual?',
    a: 'No. Pagás una sola vez y tenés el material para siempre, con actualizaciones incluidas.',
  },
  {
    q: '¿Es apto para el diseño curricular de Argentina?',
    a: 'Absolutamente. Está diseñado pensando en nuestra realidad escolar, de 1º Primaria a 6º Secundaria.',
  },
  {
    q: '¿Puedo imprimir las fichas y usarlas con varios cursos?',
    a: 'Sí. Podés imprimir todas las veces que quieras y usarlas con todos tus grupos y en los próximos ciclos lectivos. La licencia es personal, para tu uso docente.',
  },
  {
    q: '¿Qué medios de pago aceptan?',
    a: 'Tarjeta de crédito y débito, y también transferencia. El acceso se habilita apenas se acredita el pago.',
  },
]
